// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'c52ea3e1225b3af91627ad7a8be2a13ccae184fb';
export const BUILD_NUMBER = '198';
export const BUILD_TIMESTAMP = '2026-07-21T06:56:39.566Z';
